﻿import Swiper from "swiper";
import {Navigation, Pagination,Autoplay} from 'swiper/modules';

const genericContent = {
    loadScriptForPrismicKPISlider() {
        window.Cms = window.Cms || {};
        window.Cms.Kpi = window.Cms.Kpi || {};
        window.Cms.Kpi.Sliders = window.Cms.Kpi.Sliders || {};

        var cmsKpiSliders = document.querySelectorAll('.cms-slice_kpi_slider');
        for (var i = 0; i < cmsKpiSliders.length; i++) {
            var slider = cmsKpiSliders[i];
            if (!slider) {
                continue;
            }

            var slidesNumbers = slider.querySelectorAll('.cms-slice_kpi_slider_slide').length;

            var key = slider.dataset['key'];
            window.Cms.Kpi.Sliders[key] = new Swiper(`.cms-slice_kpi_slider[data-key='${key}']`, {
                speed: 500,
                initialSlide: slidesNumbers,
                autoplay: false,
                centeredSlides: true,
                pagination: false,
                navigation: {
                    disabledClass: 'cms-slice_kpi_slider_slide_header_btn-disabled',
                    nextEl: `[data-key='${key}'] .cms-slice_kpi_slider_slide_header_btn-next`,
                    prevEl: `[data-key='${key}'] .cms-slice_kpi_slider_slide_header_btn-prev`,
                },
                allowTouchMove: false,
                autoHeight: true,
                modules: [
                    Navigation, Pagination,Autoplay
                ],
            });
        }
    },
    loadScriptForPrismicCards() {
        window.Cms = window.Cms || {};
        window.Cms.Cards = window.Cms.Cards || {};
        window.Cms.Cards.Sliders = window.Cms.Cards.Sliders || {};

        var cmsCardsSliders = document.querySelectorAll('.cms-slice_cards_slider');
        for (var i = 0; i < cmsCardsSliders.length; i++) {
            var slider = cmsCardsSliders[i];
            if (!slider) {
                continue;
            }

            var key = slider.dataset['key'];
            window.Cms.Cards.Sliders[key] = new Swiper(`.cms-slice_cards_slider[data-key='${key}']`, {
                speed: 500,
                slidesPerView: +slider.dataset.mobileCount || 2,
                spaceBetween: 20,
                breakpoints: {
                    1000: {
                        slidesPerView: +slider.dataset.desktopCount || 4
                    }
                },
                autoplay: false,
                pagination: false,
                navigation: {
                    disabledClass: 'cms-slice_cards_btn-disabled',
                    nextEl: `[data-key='${key}'] .cms-slice_cards_next_btn`,
                    prevEl: `[data-key='${key}'] .cms-slice_cards_prev_btn`,
                },
                allowTouchMove: true,
                autoHeight: true,
                modules: [
                    Navigation, Pagination, Autoplay
                ],
            });
        }
    },

    loadScriptForPrismicImageBannerSlider() {
        window.Cms = window.Cms || {};
        window.Cms.ImageBanners = window.Cms.ImageBanners || {};
        window.Cms.ImageBanners.Sliders = window.Cms.ImageBanners.Sliders || {};

        var cmsImageBannersSliders = document.querySelectorAll('.cms-slice_banner-slider');
        for (var i = 0; i < cmsImageBannersSliders.length; i++) {
            var slider = cmsImageBannersSliders[i];
            if (!slider) {
                continue;
            }

            var key = slider.dataset['key'];
            var options = {
                slidesPerView: 1,
                loop: slider.dataset['loop'] === 'true',
                delay: +slider.dataset['speed'],
                pagination: {
                    el: ".cms-slice_banner-slider_pagination",
                    clickable: true,
                },
                allowTouchMove: true,
                autoHeight: true,
                modules: [
                    Navigation, Pagination,Autoplay
                ]
            };

            var autoplay = slider.dataset['autoplay'];
            if (autoplay === 'true') {
                options.autoplay = JSON.parse(slider.dataset['autoplayOptions']);
                options.delay = 3000;
            }

            window.Cms.ImageBanners.Sliders[key] = new Swiper(`.cms-slice_banner-slider[data-key='${key}']`, options);
        }
    },
    loadScriptForPrismicCollapsible() {
        const accordion = document.getElementsByClassName('cms-slice_collapsible_container');

        for (var i = 0; i < accordion.length; i++) {
            accordion[i].addEventListener('click', function () {
                this.classList.toggle('active')
            })
        }
    },
    loadScriptForPrismicRowImageTextSlider() {
        window.Cms = window.Cms || {};
        window.Cms.RowImageTextSlider = window.Cms.RowImageTextSlider || {};
        window.Cms.RowImageTextSlider.Sliders = window.Cms.RowImageTextSlider.Sliders || {};

        var cmsRowImageTextsliderSliders = document.querySelectorAll('.cms-slice_row-image-text-slider_slider');
        for (
            var i = 0; i < cmsRowImageTextsliderSliders.length; i++
        ) {
            var slider = cmsRowImageTextsliderSliders[i];
            if (!slider) {
                continue;
            }

            var key = slider.dataset['key'];
            window.Cms.RowImageTextSlider.Sliders[key] = new Swiper(`.cms-slice_row-image-text-slider_slider[data-key='${key}']`, {
                delay: 500,
                autoplay: true,
                loop: true,
                pagination: {
                    el: ".cms-slice_row-image-text-slider_pagination",
                    clickable: true,
                },
                allowTouchMove: true,
                modules: [
                    Navigation, Pagination,Autoplay
                ],
            });
        }
    },
    loadScriptForPrismicProductSlider() {
        window.Cms = window.Cms || {};
        window.Cms.ProductSlider = window.Cms.ProductSlider || {};
        window.Cms.ProductSlider.Sliders = window.Cms.ProductSlider.Sliders || {};

        var cmsProductSliders = document.querySelectorAll('.cms-slice_product-slider_slider');
        for (var i = 0; i < cmsProductSliders.length; i++) {
            var slider = cmsProductSliders[i];
            if (!slider) {
                continue;
            }

            var key = slider.dataset['key'];
            var config = {
                slidesPerView: slider.dataset['mobileCount'],
                spaceBetween: 40,
                breakpoints: {
                    1000: {
                        slidesPerView: slider.dataset['desktopCount'],
                        spaceBetween: 0,
                    },
                },
                navigation: {
                    disabledClass: 'cms-slice_product-slider_slider_swiper_button_disabled',
                    nextEl: `.cms-slice_product-slider_next-btn[data-key='${key}']`,
                    prevEl: `.cms-slice_product-slider_prev-btn[data-key='${key}']`,
                },
                modules: [
                    Navigation, Pagination, Autoplay
                ],
            };

            if (slider.dataset['loop'] === 'true') {
                config.loop = true;
            }
            else {
                config.on = {
                    touchStart: function (swiper) {
                        swiper.touches.diff = 0;
                    },
                    touchMove: function (swiper) {
                        var diffTreshold = 60;
                        var touchDirection = swiper.touches.diff + diffTreshold > 0 ? "left" : "right";
                        var currentTranslation = swiper.getTranslate();

                        if (touchDirection == "left" && currentTranslation > 30) {
                            swiper.allowTouchMove = false;
                        }
                        else if (touchDirection == "right" && swiper.isEnd) {
                            swiper.allowTouchMove = false;
                        }
                    },
                    touchEnd: function (swiper) {
                        swiper.allowTouchMove = true;
                    },
                };
            }

            window.Cms.ProductSlider.Sliders[key] = new Swiper(`.cms-slice_product-slider_slider[data-key='${key}']`, config);
        }
    }
}

window.genericContent = genericContent;